import { render, staticRenderFns } from "./DistintaMultilevel.vue?vue&type=template&id=1d4c59e0&scoped=true&"
import script from "./DistintaMultilevel.vue?vue&type=script&lang=js&"
export * from "./DistintaMultilevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c59e0",
  null
  
)

export default component.exports